<template>
  <f7-page>
    <f7-navbar title="Página no encontrada" :back-link="$t('atras')"></f7-navbar>
    <f7-block strong>
      <p>Error: Página no encontrada</p>
    </f7-block>
  </f7-page>
</template>
<script>
export default {};
</script>